module.exports = __webpack_public_path__ + "img/deborah-lee-untitled.224b6c7.jpg";